import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form } from '@ant-design/compatible';
import { Row, Col, Input } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';

import useStyles from './style';

export const LINK_PREFIX = 'http://';
export const LINK_REGEX =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

const ComposeLinkInput = ({ form, value, index, type, handleRemoveClick }) => {
  const { getFieldDecorator, getFieldValue } = form;

  const { t } = useTranslation();

  const linkInitialValue = value.link?.replace(LINK_PREFIX, '');

  const linkValue = getFieldValue(`${type}[${index}].link`) ?? linkInitialValue;

  const classes = useStyles({
    disabled: !linkValue?.match(LINK_REGEX),
  });

  const handleOpenClick = () => {
    window.open(LINK_PREFIX + linkValue, '__blank');
  };

  return (
    <Row className={classes.formInput}>
      <Col className={classes.formLeft}>
        <MinusCircleOutlined onClick={handleRemoveClick} />
      </Col>
      <Col className={classes.formMiddle}>
        <Form.Item>
          {getFieldDecorator(`${type}[${index}].link`, {
            initialValue: linkInitialValue,
            rules: [
              {
                required: true,
                message: t('cms.landlord.modal.error.blank'),
                whitespace: true,
              },
              {
                pattern: LINK_REGEX,
                message: t('cms.landlord.verification.link_address.invalid_error'),
              },
            ],
          })(
            <Input
              placeholder={t('cms.landlord.verification.placeholder.link')}
              addonBefore={LINK_PREFIX}
              addonAfter={
                <div className={classes.checkButton} onClick={handleOpenClick}>
                  {t('cms.landlord.verification.button.open')}
                </div>
              }
            />,
          )}
        </Form.Item>
      </Col>
      <Col className={classes.formRight}>
        <Form.Item>
          {getFieldDecorator(`${type}[${index}].note`, {
            initialValue: value.note,
            rules: [
              {
                max: 250,
                message: t('cms.landlord.verification.note.max_error'),
              },
            ],
          })(<Input placeholder={t('cms.landlord.verification.placeholder.note')} />)}
        </Form.Item>
      </Col>
      <Col style={{ display: 'none' }}>
        {getFieldDecorator(`${type}[${index}].id`, { initialValue: value.id })(<Input />)}
        {getFieldDecorator(`${type}[${index}].linkType`, { initialValue: value.linkType })(
          <Input />,
        )}
      </Col>
    </Row>
  );
};

ComposeLinkInput.propTypes = {
  form: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  handleRemoveClick: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default ComposeLinkInput;
